export default __webpack_public_path__ + "static/media/orientation_ALL.1a856dd2.png";